import ContractActivationDate from './ContractActivationDate'
import EmployeeOnboardingCard from './EmployeeOnboardingCard'
import Warning from './Warning'

interface Props {
  nextAvailableDate: string
  activityResumeDate: string
  setActivityResumeDate: (value: string) => void
  onboardingEnabled: boolean
  setOnboardingEnabled: (value: boolean) => void
  selectedWorkflow?: string | number
  setSelectedWorkflow: (value: string | undefined) => void
  isDisabled?: boolean
  error?: string
  isOpen?: boolean
  onToggle?: (isOpen: boolean) => void
  mandatory?: boolean
}

const FirstStep = ({
  nextAvailableDate,
  activityResumeDate,
  setActivityResumeDate,
  onboardingEnabled,
  setOnboardingEnabled,
  selectedWorkflow,
  setSelectedWorkflow,
  isDisabled,
  error,
  isOpen,
  onToggle,
  mandatory,
}: Props) => {
  return (
    <>
      <ContractActivationDate
        value={activityResumeDate}
        onChange={setActivityResumeDate}
        nextAvailableDate={nextAvailableDate}
      />

      <EmployeeOnboardingCard
        enabled={onboardingEnabled}
        onChange={setOnboardingEnabled}
        selectedWorkflow={selectedWorkflow}
        onWorkflowSelect={setSelectedWorkflow}
        isDisabled={isDisabled}
        error={error}
        isOpen={isOpen}
        onToggle={onToggle}
        mandatory={mandatory}
      />

      <Warning />
    </>
  )
}

export default FirstStep
